var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cg-alert',{attrs:{"type":"warning"}},[_vm._v("Test method")])
}
var staticRenderFns = []

export { render, staticRenderFns }